
import Vue from "vue";
import Component from "vue-class-component";
import draggable from "vuedraggable";
import {
  SplitTruckSummaryOrder,
  SplitTruckSummaryTruck,
} from "../../models/api/trucks/splitTrucks";
import {
  formatDate,
  getOrdersMapLocation,
  formatDecimal,
  formatBool,
} from "@/utils";
import SplitTruckOrdersTable from "./SplitTruckOrdersTable.vue";

import TruckModule from "@/store/modules/truck";
import {getModule} from "vuex-module-decorators";
import {getTruckCubeWarningLevel} from "@/store/modules/truck/helpers";
import {GREEN_MAP_PIN_ICON, MAP_STYLES, RED_MAP_PIN_ICON} from "@/consts";
import _ from "lodash";
import TruckCommodity from "@/components/truck/TruckCommodity.vue";
import notifications from "@/lib/notifications";

const truckModuleState = getModule(TruckModule);

declare global {
  interface Window {
    truck1InfoWindowButtonClick: Function;
    truck2InfoWindowButtonClick: Function;
    showGeoCodeAddress1: Function;
    showGeoCodeAddress2: Function;
  }
}

@Component({
  data: () => {
    return {
      customBus1: new Vue(),
      customBus2: new Vue()
    }
  },
  components: {
    TruckCommodity,
    draggable,
    SplitTruckOrdersTable,
  },
  computed: {
    truck1MapVisible() {
      return this.allowMap && this.truck1ShowMap;
    },
    truck2MapVisible() {
      return this.allowMap && this.truck2ShowMap;
    },
  },
})
export default class SplitTruckView extends Vue {
  truck1ShowMap: boolean = false;
  truck2ShowMap: boolean = false;
  truck1selectedMapOrder: SplitTruckSummaryOrder = null;
  truck2selectedMapOrder: SplitTruckSummaryOrder = null;
  tableSelectedOrder: SplitTruckSummaryOrder = null;
  truck1InfoWindowOpened: boolean = false;
  truck1InfoWindowOptions: any = null;
  truck1InfoWindowPos: any = null;
  truck2InfoWindowOpened: boolean = false;
  truck2InfoWindowOptions: any = null;
  truck2InfoWindowPos: any = null;
  mapCenter: any = null;
  mapZoomLevel: number = 10;
  allowMap: boolean = false;

  showModal1: boolean = false;
  showModal2: boolean = false;
  editLat1: number = 0;
  editLng1: number = 0;
  editLat2: number = 0;
  editLng2: number = 0;
  dragLat1: number = 0;
  dragLng1: number = 0;
  dragLat2: number = 0;
  dragLng2: number = 0;
  showCoordinateEdit1: boolean = false;
  showCoordinateEdit2: boolean = false;
  showDragActions1: boolean = false;
  showDragActions2: boolean = false;
  showGeocodeButton1: boolean = true;
  showGeocodeButton2: boolean = true;

  originalTruckOrdersWithGPS: SplitTruckSummaryOrder[] = truckModuleState.splitTruckSummary.existingTruck.orders.filter(order => order.location);
  newTruckOrdersWithGPS: SplitTruckSummaryOrder[] = truckModuleState.splitTruckSummary.newTruck.orders.filter(order => order.location);

  created() {
    const vm = this;
    window.truck1InfoWindowButtonClick = function () {
      vm.addOrderFromMap();
    };
    window.truck2InfoWindowButtonClick = function () {
      vm.removeOrderFromMap();
    };

    window.showGeoCodeAddress1 = function () {
      vm.showGeoCodeAddress1();
    }

    window.showGeoCodeAddress2 = function () {
      vm.showGeoCodeAddress2();
    }

    if (this.originalTruckOrdersWithGPS.length > 0) {
      let mapInfo = getOrdersMapLocation(this.originalTruckOrdersWithGPS);
      this.mapCenter = {lat: mapInfo.latCenter, lng: mapInfo.lngCenter};
      this.mapZoomLevel = mapInfo.zoomLevel;
      this.allowMap = true;
    }
  }

  mapOptions1() {
    return {
      styles: [
        {
          featureType: "poi",
          stylers: [{visibility: "off"}]
        },
        {
          featureType: "transit",
          elementType: "labels.icon",
          stylers: [{visibility: "off"}]
        }
      ]
    };
  }

  mapOptions2() {
    return {
      styles: [
        {
          featureType: "poi",
          stylers: [{visibility: "off"}]
        },
        {
          featureType: "transit",
          elementType: "labels.icon",
          stylers: [{visibility: "off"}]
        }
      ]
    };
  }

  mapCoordinates1() {
    if (!this.truck1selectedMapOrder
      || !this.truck1selectedMapOrder.stopParty
      || !this.truck1selectedMapOrder.stopParty.location
    ) return this.mapCenter;
    if (this.dragLat1 !== 0 && this.dragLng1 !== 0) return {lat: this.dragLat1, lng: this.dragLng1};
    return {
      lat: this.truck1selectedMapOrder.stopParty.location.latitude,
      lng: this.truck1selectedMapOrder.stopParty.location.longitude
    };
  }

  mapCoordinates2() {
    if (!this.truck2selectedMapOrder
      || !this.truck2selectedMapOrder.stopParty
      || !this.truck2selectedMapOrder.stopParty.location
    ) return this.mapCenter;
    if (this.dragLat2 !== 0 && this.dragLng2 !== 0) return {lat: this.dragLat2, lng: this.dragLng2};
    return {
      lat: this.truck2selectedMapOrder.stopParty.location.latitude,
      lng: this.truck2selectedMapOrder.stopParty.location.longitude
    };
  }

  mapCenter1() {
    if (!this.truck1selectedMapOrder
      || !this.truck1selectedMapOrder.stopParty
      || !this.truck1selectedMapOrder.stopParty.location)
      return this.mapCenter
    return {
      lat: this.truck1selectedMapOrder.stopParty.location.latitude,
      lng: this.truck1selectedMapOrder.stopParty.location.longitude
    };
  }

  mapCenter2() {
    if (!this.truck2selectedMapOrder
      || !this.truck2selectedMapOrder.stopParty
      || !this.truck2selectedMapOrder.stopParty.location)
      return this.mapCenter
    return {
      lat: this.truck2selectedMapOrder.stopParty.location.latitude,
      lng: this.truck2selectedMapOrder.stopParty.location.longitude
    };
  }

  dragEnd1(event) {
    this.dragLat1 = event.latLng.lat();
    this.dragLng1 = event.latLng.lng();
    if (this.showCoordinateEdit1 === true) {
      this.editLat1 = Number(parseFloat(event.latLng.lat()).toFixed(5));
      this.editLng1 = Number(parseFloat(event.latLng.lng()).toFixed(5));
    }
    this.showGeocodeButton1 = false;
    this.showDragActions1 = true;
  }

  dragEnd2(event) {
    this.dragLat2 = event.latLng.lat();
    this.dragLng2 = event.latLng.lng();
    if (this.showCoordinateEdit2 === true) {
      this.editLat2 = Number(parseFloat(event.latLng.lat()).toFixed(5));
      this.editLng2 = Number(parseFloat(event.latLng.lng()).toFixed(5));
    }
    this.showGeocodeButton2 = false;
    this.showDragActions2 = true;
  }

  async updateCoordinates1() {
    try {
      await truckModuleState.updateAddressCoordinatesSplitView1({
        latitude: this.dragLat1,
        longitude: this.dragLng1,
        id: this.truck1selectedMapOrder.stopParty.id,
        orderHeader: this.truck1selectedMapOrder.cdsNumber,
        orderId: this.truck1selectedMapOrder.orderId
      });
      this.updateOrder(this.truck1selectedMapOrder);
      this.resetMarker1();
      notifications.success("Address Geocoded", "Address successfully geocoded.")
      this.showModal1 = false;
    } catch {
      notifications.error("Address Not Geocoded", "Failed to geocode address.")
    }
  }

  async updateCoordinates2() {
    try {
      await truckModuleState.updateAddressCoordinatesSplitView2({
        latitude: this.dragLat2,
        longitude: this.dragLng2,
        id: this.truck2selectedMapOrder.stopParty.id,
        orderHeader: this.truck2selectedMapOrder.cdsNumber,
        orderId: this.truck2selectedMapOrder.orderId
      });
      this.updateOrder(this.truck2selectedMapOrder);
      this.resetMarker2();
      notifications.success("Address Geocoded", "Address successfully geocoded.")
      this.showModal2 = false;
    } catch {
      notifications.error("Address Not Geocoded", "Failed to geocode address.")
    }
  }

  resetMarker1() {
    this.dragLat1 = 0;
    this.dragLng1 = 0;
    this.showDragActions1 = false;
    this.showGeocodeButton1 = true;
  }

  resetMarker2() {
    this.dragLat2 = 0;
    this.dragLng2 = 0;
    this.showDragActions2 = false;
    this.showGeocodeButton2 = true;
  }

  async geoCodeAddress1() {
    try {
      await truckModuleState.geoCodeSplitViewAddress1({
        companyId: this.truck1selectedMapOrder.stopParty.id,
        orderHeader: this.truck1selectedMapOrder.cdsNumber,
        address: this.truck1selectedMapOrder.stopParty.address,
        orderId: this.truck1selectedMapOrder.orderId
      })
      notifications.success("Address Geocoded", "Address successfully geocoded.")
      this.showModal1 = false;
    } catch {
      notifications.error("Address Not Geocoded", "Failed to geocode address.")
    }
  }

  async geoCodeFromTable1(order)
  {
    let orderIndex = truckModuleState.splitTruckSummary.existingTruck.orders.findIndex(
      (x) => x.orderId == order.orderId
    );
    if(orderIndex >= 0)
    {
      this.truck1selectedMapOrder = truckModuleState.splitTruckSummary.existingTruck.orders[orderIndex];
      if(!this.truck1selectedMapOrder.stopParty || !this.truck1selectedMapOrder.stopParty.location)
      {
        let coordinates = this.mapCoordinates1();
      }
      this.showGeoCodeAddress1();
    }
  }

  async geoCodeAddress2() {
    try {
      await truckModuleState.geoCodeSplitViewAddress2({
        companyId: this.truck2selectedMapOrder.stopParty.id,
        orderHeader: this.truck2selectedMapOrder.cdsNumber,
        address: this.truck2selectedMapOrder.stopParty.address,
        orderId: this.truck2selectedMapOrder.orderId
      })
      notifications.success("Address Geocoded", "Address successfully geocoded.")
      this.showModal2 = false;
    } catch {
      notifications.error("Address Not Geocoded", "Failed to geocode address.")
    }
  }

  async geoCodeFromTable2(order)
  {    
    let orderIndex = truckModuleState.splitTruckSummary.newTruck.orders.findIndex(
      (x) => x.orderId == order.orderId
    );
    if(orderIndex >= 0)
    {
      this.truck2selectedMapOrder = truckModuleState.splitTruckSummary.newTruck.orders[orderIndex];
      if(!this.truck2selectedMapOrder.stopParty || !this.truck2selectedMapOrder.stopParty.location)
      {
        let coordinates = this.mapCoordinates2();
      }
      this.showGeoCodeAddress2();
    }
  }

  cancelGeocodeModal1() {
    this.$bvModal.hide("geocodeModalTruck1");
  }

  resetGeocodeModalTruck1()
  {
    this.resetMarker1();
    this.showCoordinateEdit1 = false;
  }

  cancelGeocodeModal2() {
    this.$bvModal.hide("geocodeModalTruck2");
  }

  resetGeocodeModalTruck2()
  {
    this.resetMarker2();
    this.showCoordinateEdit2 = false;
  }

  async saveEditCoordinate1() {
    try {
      await truckModuleState.updateAddressCoordinatesSplitView1({
        latitude: parseFloat(this.editLat1.toString()),
        longitude: parseFloat(this.editLng1.toString()),
        id: this.truck1selectedMapOrder.stopParty.id,
        orderHeader: this.truck1selectedMapOrder.cdsNumber,
        orderId: this.truck1selectedMapOrder.orderId
      });
      this.updateOrder(this.truck1selectedMapOrder);
      this.showCoordinateEdit1 = false;
      this.resetMarker1();
      notifications.success("Coordinate update successful", "Coordinate update successful.");
    } catch(ex){
      notifications.error("Update failed", "Coordinate update failed. Please try again.");
    }
  }

  async saveEditCoordinate2() {
    try {
      await truckModuleState.updateAddressCoordinatesSplitView2({
        latitude: parseFloat(this.editLat2.toString()),
        longitude: parseFloat(this.editLng2.toString()),
        id: this.truck2selectedMapOrder.stopParty.id,
        orderHeader: this.truck2selectedMapOrder.cdsNumber,
        orderId: this.truck2selectedMapOrder.orderId
      });
      this.updateOrder(this.truck2selectedMapOrder);
      this.showCoordinateEdit2 = false;
      this.resetMarker2();
      notifications.success("Coordinate update successful", "Coordinate update successful.");
    } catch {
      notifications.error("Update failed", "Coordinate update failed. Please try again.");
    }
  }

  updateOrder(order) {
    let setOriginalTruckOrders = JSON.parse(
      JSON.stringify(this.originalTruckOrders)
    );
    let originalOrderIndex = setOriginalTruckOrders.findIndex(
      (x) => x.orderId == order.orderId
    );
    if (originalOrderIndex >= 0) {
      setOriginalTruckOrders.splice(originalOrderIndex, 1, JSON.parse(JSON.stringify(order)));
      this.originalTruckOrders = setOriginalTruckOrders;
    }
    let setNewTruckOrders = JSON.parse(JSON.stringify(this.newTruckOrders));
    let newOrderIndex = setNewTruckOrders.findIndex(
      (x) => x.orderId == order.orderId
    );
    if (newOrderIndex >= 0) {
      setNewTruckOrders.splice(newOrderIndex, 1, JSON.parse(JSON.stringify(order)));
      this.newTruckOrders = setNewTruckOrders;
    }
    this.originalTruckOrdersWithGPS = truckModuleState.splitTruckSummary.existingTruck.orders.filter(order => order.location);
    this.newTruckOrdersWithGPS = truckModuleState.splitTruckSummary.newTruck.orders.filter(order => order.location);
  }

  getCurrentLat1() {
    if (this.dragLat1 === 0) {
      const valueToParse = !this.truck1selectedMapOrder ||
      !this.truck1selectedMapOrder.stopParty ||
      !this.truck1selectedMapOrder.stopParty.location
        ? 0
        : this.truck1selectedMapOrder.stopParty.location.latitude;
      return parseFloat(valueToParse).toFixed(5);
    }
    return parseFloat(this.dragLat1.toString()).toFixed(5);
  }

  getCurrentLong1() {
    if (this.dragLng1 === 0) {
      const valueToParse = !this.truck1selectedMapOrder ||
      !this.truck1selectedMapOrder.stopParty ||
      !this.truck1selectedMapOrder.stopParty.location
        ? 0
        : this.truck1selectedMapOrder.stopParty.location.longitude;
      return parseFloat(valueToParse).toFixed(5);
    }
    return parseFloat(this.dragLng1.toString()).toFixed(5);
  }

  getCurrentLat2() {
    if (this.dragLat2 === 0) {
      const valueToParse = !this.truck2selectedMapOrder ||
      !this.truck2selectedMapOrder.stopParty ||
      !this.truck2selectedMapOrder.stopParty.location
        ? 0
        : this.truck2selectedMapOrder.stopParty.location.latitude;
      return parseFloat(valueToParse).toFixed(5);
    }
    return parseFloat(this.dragLat2.toString()).toFixed(5);
  }

  getCurrentLong2() {
    if (this.dragLat2 === 0) {
      const valueToParse = !this.truck2selectedMapOrder ||
      !this.truck2selectedMapOrder.stopParty ||
      !this.truck2selectedMapOrder.stopParty.location
        ? 0
        : this.truck2selectedMapOrder.stopParty.location.longitude;
      return parseFloat(valueToParse).toFixed(5);
    }
    return parseFloat(this.dragLat2.toString()).toFixed(5);
  }


  coordinateEdit1() {
    this.showCoordinateEdit1 = true;
    this.editLat1 = parseFloat(this.getCurrentLat1());
    this.editLng1 = parseFloat(this.getCurrentLong1());
  }

  coordinateEdit2() {
    this.showCoordinateEdit2 = true;
    this.editLat2 = parseFloat(this.getCurrentLat2());
    this.editLng2 = parseFloat(this.getCurrentLong2());
  }

  async showGeoCodeAddress1() {
    this.showModal1 = true;
  }

  async showGeoCodeAddress2() {
    this.showModal2 = true;
  }

  getTotalWeight(truck: any) {
    if (!truck) return 0;
    return _.sumBy(truck.orders, x => {
      return x.weight;
    })
  }

  getTotalUnits(truck: any) {
    if (!truck) return 0;
    return _.sumBy(truck.orders, x => {
      return x.unitCount;
    })
  }

  get originalTruckWeight() {
    return truckModuleState.splitTruckSummary.existingTruck.weight;
  }

  get originalTruckTotalUnits() {
    return truckModuleState.splitTruckSummary.existingTruck.totalUnits;
  }

  get originalTruckDeliveryDate() {
    return truckModuleState.splitTruckSummary.existingTruck.deliveryDate;
  }

  set originalTruckDeliveryDate(val) {
    truckModuleState.setSplitTruckSummaryDeliveryDate({
      original: true,
      value: val,
    });
  }

  get originalTruckName() {
    return truckModuleState.splitTruckSummary.existingTruck.truckName;
  }

  set originalTruckName(val) {
    truckModuleState.setSplitTruckSummaryTruckName({
      original: true,
      value: val,
    });
  }

  get originalTruckDriverName() {
    return truckModuleState.splitTruckSummary.existingTruck.driver;
  }

  set originalTruckDriverName(val) {
  }

  get originalTruckMaxCubes() {
    return truckModuleState.splitTruckSummary.existingTruck.maxCubes;
  }

  set originalTruckMaxCubes(val) {
    truckModuleState.setSplitTruckSummaryMaxCubes({
      original: true,
      value: val,
    });
  }

  get originalTruckOrders(): SplitTruckSummaryOrder[] {
    return truckModuleState.splitTruckSummary.existingTruck.orders;
  }

  set originalTruckOrders(val) {
    truckModuleState.setSplitTruckSummaryOriginalOrders(val);
  }

  get originalTruckAllOrdersReceived(): boolean {
    return this.originalTruckOrders.filter((x) => !x.isReceived).length == 0;
  }

  set originalTruckAllOrdersReceived(val) {
  }

  get originalTruckZips() {
    return truckModuleState.splitTruckSummary.existingTruck.zip3sServiced.join(', ');
  }

  set originalTruckZips(val) {
  }


  get newTruckOrders(): SplitTruckSummaryOrder[] {
    return truckModuleState.splitTruckSummary.newTruck.orders;
  }

  set newTruckOrders(val) {
    truckModuleState.setSplitTruckSummaryNewOrders(val);
  }

  get newTruckAllOrdersReceived(): boolean {
    return this.newTruckOrders.filter((x) => !x.isReceived).length == 0;
  }

  set newTruckAllOrdersReceived(val) {
  }

  get newTruckDeliveryDate() {
    return truckModuleState.splitTruckSummary.newTruck.deliveryDate;
  }

  set newTruckDeliveryDate(val) {
  }

  get newTruckName() {
    return truckModuleState.splitTruckSummary.newTruck.truckName;
  }

  set newTruckName(val) {
    truckModuleState.setSplitTruckSummaryTruckName({
      original: false,
      value: val,
    });
  }

  get newTruckDriverName() {
    return truckModuleState.splitTruckSummary.newTruck.driver;
  }

  get newTruckMaxCubes() {
    return truckModuleState.splitTruckSummary.newTruck.maxCubes;
  }

  set newTruckMaxCubes(val) {
    truckModuleState.setSplitTruckSummaryMaxCubes({
      original: false,
      value: val,
    });
  }

  get newTruckZips() {
    return truckModuleState.splitTruckSummary.newTruck.zip3sServiced;
  }

  set newTruckZips(val) {
    truckModuleState.setSplitTruckSummaryZips({original: false, value: val});
  }

  getTotalCubesForTruck(truck: SplitTruckSummaryTruck): number {
    return truck.orders.reduce((sum, item) => sum + item.cubes, 0);
  }

  format(date) {
    return formatDate(date);
  }

  formatDecimal(value) {
    return formatDecimal(value);
  }

  formatBool(value) {
    return formatBool(value);
  }

  get summary() {
    return truckModuleState.splitTruckSummary;
  }

  getCubeWarningClass(truck: SplitTruckSummaryTruck): string {
    let warningLevel = getTruckCubeWarningLevel(
      this.getTotalCubesForTruck(truck),
      truck.maxCubes
    );
    return "truck-cube-warning-" + warningLevel.toString();
  }

  getOrderPosition(order: SplitTruckSummaryOrder) {
    if (order && order.location)
      return {lat: order.location.latitude, lng: order.location.longitude};
    return null;
  }

  getTruck1MarkerLabel(order: any) {
    var index = this.originalTruckOrders.findIndex(
      (x) => x.orderId == order.orderId
    );
    if (index >= 0) return {color: "white", text: (index + 1).toString()};
    return null;
  }

  getTruck2MarkerLabel(order: any) {
    var index = this.newTruckOrders.findIndex(
      (x) => x.orderId == order.orderId
    );
    if (index >= 0) return {color: "white", text: (index + 1).toString()};
    return null;
  }

  getOrderMapIcon(order: any) {
    if (order && order.location && order.location.isZipCodeLocation == true)
      return RED_MAP_PIN_ICON;
    return GREEN_MAP_PIN_ICON;
  }

  getMapOptions() {
    return MAP_STYLES;
  }

  toggleTruck1MapButtonText() {
    return this.truck1ShowMap ? "Hide Map" : "Show Map";
  }

  toggleTruck2MapButtonText() {
    return this.truck2ShowMap ? "Hide Map" : "Show Map";
  }

  toggleTruck1Map() {
    return (this.truck1ShowMap = !this.truck1ShowMap);
  }

  toggleTruck2Map() {
    return (this.truck2ShowMap = !this.truck2ShowMap);
  }

  getTruck1InfoWindowOptions() {
    if (this.truck1selectedMapOrder) {
      var index =
        this.originalTruckOrders.findIndex(
          (x) => x.orderId == this.truck1selectedMapOrder.orderId
        ) + 1;
      return {
        content:
          "<h5>" +
          index.toString() + " - " + this.truck1selectedMapOrder.stopParty.name +
          "</h5><b>SYS #:</b> " +
          this.truck1selectedMapOrder.cdsNumber +
          "<br> <b>CRN:</b> " +
          this.truck1selectedMapOrder.crn +
          "<br> <b>Cubes:</b> " +
          this.truck1selectedMapOrder.cubes +
          "<br> <b>Received:</b> " +
          formatBool(this.truck1selectedMapOrder.isReceived) +
          "<br><b>Unit Count:</b>" +
          this.truck1selectedMapOrder.unitCount +
          "<br/><br>" +
          this.truck1selectedMapOrder.stopParty.name +
          "<br/>" +
          this.truck1selectedMapOrder.stopParty.address.streetLine1 +
          "<br/>" +
          this.truck1selectedMapOrder.stopParty.address.city +
          ", " +
          this.truck1selectedMapOrder.stopParty.address.state +
          " " +
          this.truck1selectedMapOrder.stopParty.address.zip +
          "<br/><br/>" +
          "<a href='javascript:void(0)' onclick='truck1InfoWindowButtonClick()'>Add To New Truck</a>"
          + "<br> <a href='javascript:void(0)' onclick='showGeoCodeAddress1()'>Geocode Address</a>",
      };
    }
    return null;
  }

  getTruck2InfoWindowOptions() {
    if (this.truck2selectedMapOrder) {
      var index =
        this.newTruckOrders.findIndex(
          (x) => x.orderId == this.truck2selectedMapOrder.orderId
        ) + 1;
      return {
        content:
          "<h5>" +
          index.toString() + " - " + this.truck2selectedMapOrder.stopParty.name +
          "</h5><b>SYS #:</b> " +
          this.truck2selectedMapOrder.cdsNumber +
          "<br> <b>CRN:</b> " +
          this.truck2selectedMapOrder.crn +
          "<br> <b>Cubes:</b> " +
          this.truck2selectedMapOrder.cubes +
          "<br> <b>Received:</b> " +
          formatBool(this.truck2selectedMapOrder.isReceived) +
          "<br/><b>Unit Count:</b>" +
          this.truck2selectedMapOrder.unitCount +
          "<br><br>" +
          this.truck2selectedMapOrder.stopParty.name +
          "<br/>" +
          this.truck2selectedMapOrder.stopParty.address.streetLine1 +
          "<br/>" +
          this.truck2selectedMapOrder.stopParty.address.city +
          ", " +
          this.truck2selectedMapOrder.stopParty.address.state +
          " " +
          this.truck2selectedMapOrder.stopParty.address.zip +
          "<br/><br/>" +
          "<a href='javascript:void(0)' onclick='truck2InfoWindowButtonClick()'>Remove From New Truck</a>" +
          "<br> <a href='javascript:void(0)' onclick='showGeoCodeAddress2()'>Geocode Address</a>"
        ,
      };
    }
    return null;
  }

  truck1OrderListMapPinClicked(order) {
    let mapOrderIndex = this.originalTruckOrdersWithGPS.findIndex(
        (x) => x.orderId == order.orderId
    );
    if(mapOrderIndex != null)
    {
      this.truck1ShowMap = true;
      var el = document.getElementById("truck1-map");
      if (el) el.scrollIntoView();
      this.selectTruck1MapOrder(this.originalTruckOrdersWithGPS[mapOrderIndex]);
    }
  }

  truck2OrderListMapPinClicked(order) {
    let mapOrderIndex = this.newTruckOrdersWithGPS.findIndex(
        (x) => x.orderId == order.orderId
    );
    if(mapOrderIndex != null)
    {
      this.truck2ShowMap = true;
      var el = document.getElementById("truck2-map");
      if (el) el.scrollIntoView();
      this.selectTruck2MapOrder(this.newTruckOrdersWithGPS[mapOrderIndex]);
    }
  }

  selectTruck1MapOrder(order) {
    this.truck1selectedMapOrder = order;
    this.truck1InfoWindowOpened = order != null;
    this.truck1InfoWindowOptions = this.getTruck1InfoWindowOptions();
    this.truck1InfoWindowPos = this.getOrderPosition(order);
  }

  selectTruck2MapOrder(order) {
    this.truck2selectedMapOrder = order;
    this.truck2InfoWindowOpened = order != null;
    this.truck2InfoWindowOptions = this.getTruck2InfoWindowOptions();
    this.truck2InfoWindowPos = this.getOrderPosition(order);
  }

  addOrderFromMap() {
    if (this.truck1selectedMapOrder) {
      let setOriginalTruckOrders = JSON.parse(
        JSON.stringify(this.originalTruckOrders)
      );
      let setNewTruckOrders = JSON.parse(JSON.stringify(this.newTruckOrders));
      let addOrderIndex = setOriginalTruckOrders.findIndex(
        (x) => x.orderId == this.truck1selectedMapOrder.orderId
      );
      if (addOrderIndex >= 0) {
        setNewTruckOrders.push(this.originalTruckOrders[addOrderIndex]);
        setOriginalTruckOrders.splice(addOrderIndex, 1);
        this.originalTruckOrders = setOriginalTruckOrders;
        this.newTruckOrders = setNewTruckOrders;
      }
      this.selectTruck1MapOrder(null);

      this.originalTruckOrdersWithGPS = truckModuleState.splitTruckSummary.existingTruck.orders.filter(order => order.location);
      this.newTruckOrdersWithGPS = truckModuleState.splitTruckSummary.newTruck.orders.filter(order => order.location);
    }
  }

  addOrderFromMapQuick(order) {
    this.selectTruck1MapOrder(order);
    this.addOrderFromMap();
  }

  removeOrderFromMap() {
    if (this.truck2selectedMapOrder) {
      let setOriginalTruckOrders = JSON.parse(
        JSON.stringify(this.originalTruckOrders)
      );
      let setNewTruckOrders = JSON.parse(JSON.stringify(this.newTruckOrders));
      let removeOrderIndex = setNewTruckOrders.findIndex(
        (x) => x.orderId == this.truck2selectedMapOrder.orderId
      );
      if (removeOrderIndex >= 0) {
        setOriginalTruckOrders.push(this.newTruckOrders[removeOrderIndex]);
        setNewTruckOrders.splice(removeOrderIndex, 1);
        this.originalTruckOrders = setOriginalTruckOrders;
        this.newTruckOrders = setNewTruckOrders;
      }
      this.selectTruck2MapOrder(null);

      this.originalTruckOrdersWithGPS = truckModuleState.splitTruckSummary.existingTruck.orders.filter(order => order.location);
      this.newTruckOrdersWithGPS = truckModuleState.splitTruckSummary.newTruck.orders.filter(order => order.location);
    }
  }

  removeOrderFromMapQuick(order) {
    this.selectTruck2MapOrder(order);
    this.removeOrderFromMap();
  }

  removeNewTruckOrder(order) {
    let setOriginalTruckOrders = JSON.parse(
      JSON.stringify(this.originalTruckOrders)
    );
    let setNewTruckOrders = JSON.parse(JSON.stringify(this.newTruckOrders));
    let removeOrderIndex = setNewTruckOrders.findIndex(
      (x) => x.orderId == order.orderId
    );
    if (removeOrderIndex >= 0) {
      setOriginalTruckOrders.push(this.newTruckOrders[removeOrderIndex]);
      setNewTruckOrders.splice(removeOrderIndex, 1);
      this.originalTruckOrders = setOriginalTruckOrders;
      this.newTruckOrders = setNewTruckOrders;
    }
  }
}
